/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Ai_AssistantInputs */



/**
* | output |
* | --- |
* | "Toggle AI Assistant" |
*
* @param {Shortcut_Keys_Name_Toggle_Ai_AssistantInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_ai_assistant = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Ai_AssistantInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Ai_AssistantInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer/désactiver l'assistant IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Assistent aktivieren/deaktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva Assistente AI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить/Выключить ИИ-помощника")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar/desactivar el asistente de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换人工智能助手")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントの切り替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई सहायक को टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar assistente de IA")
	return /** @type {LocalizedString} */ ("Toggle AI Assistant")
});